import { render, staticRenderFns } from "./sbsxcx.vue?vue&type=template&id=2d2b32fd&scoped=true"
import script from "./sbsxcx.vue?vue&type=script&lang=js"
export * from "./sbsxcx.vue?vue&type=script&lang=js"
import style0 from "./sbsxcx.vue?vue&type=style&index=0&id=2d2b32fd&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2b32fd",
  null
  
)

export default component.exports